import React, { Fragment } from 'react';
import {
  Datagrid,
  Filter,
  TextField,
  TextInput,
  TopToolbar,
  usePermissions,
  Button,
} from 'react-admin';
import { List } from '~/layout';
import CreateAction from './components/CreateAction';
import { NoPermissions } from '~/components/ra';
import { SvgIcon } from '@material-ui/core';
import { SettingsIcon } from '~/img';
import { useHistory } from 'react-router-dom';
import SearchAction from './components/SearchItem';
import { useDefaultListFilterStyles } from '~/hooks/useListFilterStyles';

export const l = (key: string): string => `resources.menu.list.${key}`;

const MenuListActions = () => {
  const { permissions } = usePermissions();
  const history = useHistory();
  if (!permissions) return null;
  return (
    <TopToolbar>
      <SearchAction />
      <CreateAction selectedType='menu' />
      <Button label={l('mappings')} onClick={() => history.push('/menu/mappings')}>
        <SvgIcon>
          <SettingsIcon />
        </SvgIcon>
      </Button>
    </TopToolbar>
  );
};

const MenuList = (props: any) => {
  const { permissions } = usePermissions();
  const classes = useDefaultListFilterStyles();

  if (!permissions) return null;
  if (!permissions?.includes('dynamicMenu.list')) return <NoPermissions />;
  return (
    <Fragment>
      <List
        bulkActionButtons={false}
        {...props}
        actions={<MenuListActions {...props} />}
        filters={
          <Filter className={classes.form}>
            <TextInput label={l('name')} source='name' alwaysOn className={classes.formControl} />
            <TextInput label={l('code')} source='code' alwaysOn className={classes.formControl} />
          </Filter>
        }
      >
        <Datagrid rowClick='show' size='medium' selectedIds={null}>
          <TextField source='name' label={l('name')} sortable={false} />
          <TextField source='code' label={l('code')} sortable={false} />
        </Datagrid>
      </List>
    </Fragment>
  );
};

export default MenuList;
